<template>
  <div>
    <div class="nk-app-root">
      <!-- main @s -->
      <div class="nk-main">
        <!-- wrap @s -->
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <!-- main header @e -->
          <!-- content @s -->
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <!--
                <div class="nk-content-body" v-show="loading_page">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                -->

                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block-head nk-block-head-lg">
                      <div class="nk-block-between-md g-4">
                        <div class="nk-block-head-content">
                          <h2 class="nk-block-title fw-normal">
                            {{ $t('dash_projects') }}
                          </h2>
                          <p>
                            {{ projects ? projects.length : 0 }} {{ $t('dash_projects_available') }}
                            <span v-if="companyName"> &middot; {{ companyName }}</span>
                          </p>
                        </div>
                        <div class="nk-block-head-content">
                          <div class="btn btn-primary" @click="addProject()" v-if="canAddProject">
                            <em class="icon ni ni-plus" style="margin-right: 6px;"></em>
                            <span>{{ $t('dash_add_project') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- .nk-block-head -->

                    <div class="nk-block nk-block-lg">
                      <div class="search-input-wrap" style="margin-bottom: 20px">
                        <div class="search-input">
                          <em class="icon ni ni-search search-input-icon"></em>
                          <input v-model="searchkey" type="text" class="form-control search-field" :placeholder="$t('dash_search_projects')" />
                        </div>
                      </div>

                      <div class="card">
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th scope="col" class="sortable-th" @click="sortCol('projectnumber')">
                                  {{ $t('dash_col_project') }}
                                  <em class="icon ni sort-icon" :class="sortIcon('projectnumber')"></em>
                                </th>
                                <th scope="col" class="sortable-th" @click="sortCol('projectname')">
                                  {{ $t('common_name') }}
                                  <em class="icon ni sort-icon" :class="sortIcon('projectname')"></em>
                                </th>
                                <th scope="col" class="sortable-th hide-mobile" @click="sortCol('customer')">
                                  {{ $t('dash_col_customer') }}
                                  <em class="icon ni sort-icon" :class="sortIcon('customer')"></em>
                                </th>
                                <th scope="col" class="hide-mobile" style="width: 80px">
                                  {{ $t('common_status') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in projects" :key="item.uid" class="table-row" @click="selectProject(item)">
                                <td class="project-number">{{ item.projectnumber }}</td>
                                <td class="project-name">{{ item.projectname }}</td>
                                <td class="hide-mobile">{{ item.customer }}</td>
                                <td class="hide-mobile">
                                  <span v-if="item.external" class="status-badge status-external" :title="$t('dash_external')">
                                    <em class="icon ni ni-cloud"></em>
                                  </span>
                                  <span v-if="item.collaborator && !item.member" class="status-badge status-collab" :title="$t('dash_collaborator')">
                                    <em class="icon ni ni-users"></em>
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!projects || projects.length === 0">
                                <td colspan="4" class="text-center" style="padding: 40px;">
                                  <em class="icon ni ni-search" style="font-size: 24px; color: var(--text-muted); display: block; margin-bottom: 8px;"></em>
                                  <span style="color: var(--text-muted);">{{ $t('dash_no_projects') }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!--
                      <v-grid
                        style="height: 500px"
                        theme="compact"
                        resize="true"
                        auto-size-column="true"
                        :source="projects"
                        :columns="columns"
                        readonly="true"
                        canFocus="false"
                        v-if="projects && projects.length > 0"
                      ></v-grid>
-->
                    </div>

                    <div class="example-alert" v-if="hasExternalProjects">
                      <div class="alert alert-light alert-icon">
                        <em class="icon ni ni-alert-circle"></em> {{ $t('dash_external_info') }}
                      </div>
                    </div>

                    <!-- .nk-block -->
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
          <!-- content @e -->
        </div>
        <!-- wrap @e -->
      </div>
      <!-- main @e -->

      <!-- Modal Content Code -->
      <div class="modal fade" tabindex="-1" id="modalDefault">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <a href="#" class="close" data-dismiss="modal" aria-label="Close">
              <em class="icon ni ni-cross"></em>
            </a>
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('dash_add_new_project') }}</h5>
            </div>
            <div class="modal-body">
              <div class="alert alert-danger" v-if="errorMessage">
                {{ errorMessage }}
              </div>
              <form action="#" class="form-validate is-alter" novalidate="novalidate">
                <div class="form-group">
                  <div class="row gy-4">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="form-label" for="default-01">{{ $t('dash_project_number') }}</label>
                        <div class="form-control-wrap">
                          <input :placeholder="$t('common_min_5_chars')" type="text" class="form-control"
                            v-model="projectEntry.projectNumber" />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="form-label" for="default-01">{{ $t('common_name') }}</label>
                        <div class="form-control-wrap">
                          <input :placeholder="$t('common_min_5_chars')" type="text" class="form-control"
                            v-model="projectEntry.name" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <button v-if="!projectLoading" type="button" class="btn btn-lg btn-primary"
                    @click="createProject(projectEntry)">
                    {{ $t('dash_save_project') }}
                  </button>
                </div>
              </form>
            </div>
            <div class="modal-footer bg-light"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import VGrid, { VGridVueTemplate } from "@revolist/vue-datagrid";
import Header from "../../components/Header.vue";
import Navigation from "../../components/Navigation.vue";
import Footer from "../../components/Footer.vue";
import { accountSetup } from "@/services/login.service";

//import { EventBus } from '@/event-bus.js';
import { createProject } from "@/services/project.service";

export default {
  name: "Home",
  data() {
    return {
      fullLoader: null,
      projectEntry: {},
      mapSort: {},
      searchkey: "",
      db_result: [],
      errorMessage: '',
      projectLoading: false,
      columns: [
        { prop: "projectnumber", name: "Project", sortable: true, size: 100 },
        { prop: "projectname", name: "Name", sortable: true, size: 200 },
        { prop: "customer", name: "Customer", sortable: true, size: 200 },
        // { prop: "external", name: "External", sortable: true  },
      ],
      rows: [],
    };
  },
  components: {
    Header,
    Navigation,
    Footer,
    //VGrid
  },

  computed: {
    hasExternalProjects: function () {
      if (this.db_result) {
        for (let k = 0; k < this.db_result.length; k++) {
          if (this.db_result[k].external) {
            return true;
          }
        }
      }
      return false;
    },

    canAddProject: function () {
      return this.$store.state.login_system == "inspect";
    },
    companyName: function () {
      return this.$store.state.company;
    },
    loginName: function () {
      return this.$store.state.name;
    },
    projects_db: function () {
      return this.$store.state.projects;
    },
    loading_page: function () {
      return (
        this.$store.state.loading_page &&
        this.$store.state.loading_page == "setup"
      );
    },
    projects() {
      if (this.searchkey && this.searchkey.length > 2) {
        return this.db_result.filter((project) => {
          return (
            (project.projectname &&
              project.projectname
                .toLowerCase()
                .indexOf(this.searchkey.toLowerCase()) !== -1) ||
            (project.projectnumber &&
              project.projectnumber
                .toLowerCase()
                .indexOf(this.searchkey.toLowerCase()) !== -1) ||
            (project.customer &&
              project.customer
                .toLowerCase()
                .indexOf(this.searchkey.toLowerCase()) !== -1)
          );
        });
      }

      return this.db_result;
    },
  },
  mounted() {
    this.db_result = this.projects_db;
    window.scrollTo(0, 0);
  },
  created() {
    //EventBus.$off('project:table:select');
    //EventBus.$on('project:table:select', this.selectProject);

    //this.$store.state.account_setup = false;
    if (!this.$store.state.account_setup) {
      this.$store.state.account_setup = true;

      this.$store.commit("set_loading_page", "setup");
      this.showLoader();
      accountSetup()
        .then((d) => {
          this.hideLoder();
          if (d.data.name) {
            this.$store.state.name = d.data.name;
          }
          if (d.data.projects) {

            let newTestProject = JSON.parse(JSON.stringify(this.$store.state.testProject))

            console.log("hallo", d.data, this.$store.state.userId)

            if (d.data.userId && !d.data.old_testproject) {
              newTestProject.projectId = "00000000" + d.data.userId
              newTestProject._id = "00000000" + d.data.userId
              newTestProject.uid = "00000000" + d.data.userId
              newTestProject.projectnumber = "00000000" + d.data.userId
            }


            this.$store.commit("set_projects", d.data.projects);
          } else {
            this.$store.commit("set_projects", [this.$store.state.testProject]);
          }

          if (d.data.account_role) {
            this.$store.state.account_role = d.data.account_role;
          }

          this.$store.commit("set_loading_page", null);
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    }
  },
  watch: {
    "$store.state.projects": function () {
      this.db_result = this.$store.state.projects;
    },
  },
  methods: {
    selectProject: function (data) {
      this.$router.push({ name: "project", params: { uid: data.uid } });
    },
    hideLoder: function () {
      if (this.fullLoader) {
        this.fullLoader.hide();
      }
    },
    sortByKey(key, idx) {
      if (idx == -1) {
        return (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
      } else {
        return (a, b) => (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0);
      }
    },

    sortIcon(col) {
      if (!this.mapSort[col]) return 'ni-arrow-long-down';
      return this.mapSort[col] === 1 ? 'ni-arrow-long-up' : 'ni-arrow-long-down';
    },
    sortCol(val) {
      if (!this.mapSort[val]) {
        this.mapSort[val] = 1;
      } else {
        this.mapSort[val] = this.mapSort[val] * -1;
      }

      this.db_result = this.db_result.sort(
        this.sortByKey(val, this.mapSort[val])
      );
    },
    addProject: function () {
      this.projectEntry = {};
      this.errorMessage = ''
      $("#modalDefault").modal("show");
    },
    createProject: function () {
      this.errorMessage = ''
      if (
        this.projectEntry.name &&
        this.projectEntry.name.length > 4 &&
        this.projectEntry.projectNumber &&
        this.projectEntry.projectNumber.length > 4
      ) {
        this.projectLoading = true;
        createProject(
          this.projectEntry.projectNumber,
          this.projectEntry.name
        ).then((data) => {
          this.projectLoading = false;

          if (data.data.error) {
            this.errorMessage = this.$t('dash_project_exists')
          } else {
            $("#modalDefault").modal("hide");
            if (data.data.list) {
              this.$store.commit("set_projects", data.data.list);
            }

            if (data.data.project) {
              this.$router.push({
                name: "project",
                params: { uid: data.data.project.uid },
              });
            }
          }
        });
      }
    },
    showLoader: function () {
      this.fullLoader = this.$loading.show({
        container: null,
        canCancel: false,
        height: 40,
        width: 40,
        loader: "spinner",
        color: "#E8751A",
        backgroundColor: "#F5F5F3",
        opacity: 0.7,
      });
    },
  },
};
</script>

<style scoped>
.search-input {
  position: relative;
}

.search-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  font-size: 16px;
  pointer-events: none;
}

.search-field {
  padding-left: 40px !important;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.sort-icon {
  font-size: 10px !important;
  margin-left: 4px;
  opacity: 0.3;
  vertical-align: middle;
}

.sortable-th:hover .sort-icon {
  opacity: 0.7;
}

.project-number {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
  font-family: 'SF Mono', 'Fira Code', monospace;
}

.project-name {
  font-weight: 500;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 4px;
}

.status-external {
  background: rgba(232, 117, 26, 0.1);
  color: var(--accent);
}

.status-collab {
  background: rgba(37, 99, 235, 0.1);
  color: #2563EB;
}

.table-row {
  cursor: pointer;
  transition: background-color 0.1s ease;
}
</style>
